import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Icon from "@material-ui/core/Icon";
import PropTypes from "prop-types";
import CardFooter from "components/Card/CardFooter.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import { fetchWorkspace } from "../../api/workspace";
import Danger from "components/Typography/Danger.jsx";
import Warning from "@material-ui/icons/Warning";
import { withRouter } from "react-router-dom";

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      show: false,
      totworkspace: 0
    };
  }

  componentWillMount(){
    fetchWorkspace()
      .then(response => {
        console.log(response);
        this.setState({totworkspace: response.data.count})
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.alert}
        <GridContainer>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Icon>file_copy</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Workspace</p>
                <h3 className={classes.cardTitle}>
                  {this.state.totworkspace}/10 <small>Modules</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Danger>
                    <Warning />
                  </Danger>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    Get more space
                  </a>
                </div>
              </CardFooter>
            </Card>
          </GridItem>

        </GridContainer>
      </div>
    );
  }
}

Info.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(dashboardStyle)(Info));
